import { lazy } from 'react';

// project-imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';

// render - login
const AuthLogin = Loadable(lazy(() => import('pages/auth/login')));
// const AuthRegister = Loadable(lazy(() => import('pages/auth/register')));
const AuthRegisterNew = Loadable(lazy(() => import('pages/auth/register-new')));
const AuthCodeVerification = Loadable(lazy(() => import('pages/auth/code-verification')));
const AuthForgotPassword = Loadable(lazy(() => import('pages/auth/forgot-password')));
const AuthResetPassword = Loadable(lazy(() => import('pages/auth/reset-password')));
const AuthCreatePassword = Loadable(lazy(() => import('pages/auth/create-password')));
const AuthCreatePasswordFreemium = Loadable(lazy(() => import('pages/auth/create-password-freemium')));
const AuthCreatePasswordInternational = Loadable(lazy(() => import('pages/auth/create-password-international')));
// const AuthCheckMail = Loadable(lazy(() => import('pages/auth/check-mail')));

// ==============================|| AUTH ROUTES ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <GuestGuard>
          <CommonLayout />
        </GuestGuard>
      ),
      children: [
        {
          path: '/',
          element: <AuthLogin />
        },
        {
          path: 'login',
          element: <AuthLogin />
        },
        // {
        //   path: 'signup',
        //   element: <AuthRegister />
        // },
        {
          path: 'signup',
          element: <AuthRegisterNew />
        },
        {
          path: 'code-verification',
          element: <AuthCodeVerification />
        },
        {
          path: 'forgot-password',
          element: <AuthForgotPassword />
        },
        {
          path: 'reset-password',
          element: <AuthResetPassword />
        },
        {
          path: 'create-password',
          element: <AuthCreatePassword />
        },
        {
          path: 'create-password-freemium',
          element: <AuthCreatePasswordFreemium />
        },
        {
          path: 'create-password-international',
          element: <AuthCreatePasswordInternational />
        }
        // {
        //   path: 'check-mail',
        //   element: <AuthCheckMail />
        // }
      ]
    }
  ]
};

export default LoginRoutes;
